var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Lightbulb--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Lightbulb Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb--lighting-light-incandescent-bulb-lights"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffe70d",
    fillRule: "evenodd",
    d: "M9.5 9.33109C10.9945 8.46657 12 6.85071 12 5c0 -2.76142 -2.23858 -5 -5 -5S2 2.23858 2 5c0 1.85071 1.0055 3.46657 2.5 4.33109V10.5c0 0.5523 0.44772 1 1 1h3c0.55228 0 1 -0.4477 1 -1V9.33109ZM4.5 13.25c0 -0.4142 0.33579 -0.75 0.75 -0.75h3.5c0.41421 0 0.75 0.3358 0.75 0.75s-0.33579 0.75 -0.75 0.75h-3.5c-0.41421 0 -0.75 -0.3358 -0.75 -0.75Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipBulb);
export default __webpack_public_path__ + "static/media/tip-bulb.92ef9a7f19eca88834ce827140e9c5d0.svg";
export { ForwardRef as ReactComponent };